import React, { useState } from 'react'
import FormElement from './FormElement'
import Detail from './Detail'
import TableDataSSR from './TableDataSSR'

function Index() {
    const [content, setContent] = useState('table')
    const [rowId, setRowId] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [filters, setFilters] = useState({})
    const [params, setParams] = useState('')


    const showTable = () => {
        setContent('table')
    }

    const showDetail = (id) => {
        setRowId(id)
        setContent('detail')
    }

    const showForm = (type, id) => {
        if (type === 'Edit') {
            setRowId(id)
        }
        setContent('form' + type)
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (
                    <TableDataSSR
                        showForm={showForm}
                        showDetail={showDetail}
                        indexSetPage={setPage}
                        indexSetRowsPerPage={setRowsPerPage}
                        indexSetFilters={setFilters}
                        indexSetParams={setParams}
                        initialPage={page}
                        initialRowsPerPage={rowsPerPage}
                        initialFilters={filters}
                        initialParams={params}
                    />
                )
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement type="edit" showTable={showTable} rowId={rowId} />)
            case 'detail':
                return (<Detail showTable={showTable} rowId={rowId} />)
            default:
                return <>Nothing to show here</>
        }
    }

    return (
        <>
            {
                renderContent(content)
            }
        </>
    )
}

export default Index
